import styled from 'styled-components';

import Hero from '../../../images/company/hero-bg.png';

export const MainStyled = styled.div`
  background-image: url(${Hero});
  background-repeat: no-repeat;
  background-size: 170%;
  background-position: 50% -235%;
  background-color: var(--dblue);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  position: relative;
  > .content {
    display: flex;
    flex-direction: column-reverse;
    padding: 0 20px;
    padding-bottom: 145px;
    @media (min-width: 992px) {
      flex-direction: row;
      align-items: flex-start;
      justify-content: space-between;
      height: 1000px;
      padding: 0;
      width: 100%;
      padding-right: 490px;
    }
    @media (min-width: 1366px) {
      padding-right: 210px;
      height: 800px;
    }
    @media (min-width: 1440px) {
      padding-right: 260px;
    }
    @media (min-width: 1920px) {
      padding-right: 500px;
    }
    @media (min-width: 2520px) {
      padding-right: 720px;
    }
  }
  > img {
    position: absolute;
    width: 360px;
    top: 430px;
    right: 0;
    z-index: 1;
    @media (min-width: 768px) {
      top: 260px;
    }
    @media (min-width: 992px) {
      display: none;
    }
  }
  @media (min-width: 768px) {
    background-size: 100%;
    background-position: 50% 45%;
  }
  @media (min-width: 992px) {
    background-size: 80%;
    background-position: 240px 45%;
  }
  @media (min-width: 1920px) {
    background-size: 60%;
    background-position: 480px 45%;
  }
`;

export const TextColumn = styled.div`
  margin-top: 180px;
  @media (min-width: 310px) {
    margin-top: 160px;
  }
  @media (min-width: 385px) {
    margin-top: 140px;
  }
  @media (min-width: 660px) {
    margin-top: 112px;
  }
  @media (min-width: 992px) {
    max-width: 456px;
    width: 100%;
    margin-top: 198px;
  }
`;

export const Title = styled.h1`
  color: var(--white);
  font-family: Rubik;
  font-size: 48px;
  font-weight: bold;
  letter-spacing: -1px;
  line-height: 56px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    font-size: 64px;
    line-height: 72px;
    letter-spacing: -2px;
  }
`;

export const Subtitle = styled.p`
  color: var(--white);
  font-family: Rubik;
  font-size: 16px;
  letter-spacing: 0;
  line-height: 24px;
  margin-top: 27px;
  strong {
    font-weight: bold;
  }
  @media (min-width: 992px) {
    font-size: 16px;
    line-height: 32px;
    margin-top: 37px;
  }
`;

export const ImageColumn = styled.div`
  position: absolute;
  z-index: 1;
  margin-top: 20px;
  right: -60px;
  img {
    object-fit: cover;
    width: 100%;
    display: none;
    height: 360px;
    width: 744px;
    margin-top: 200px;
    margin-left: -90px;
    @media (min-width: 992px) {
      display: inline;
    }
  }
  @media (min-width: 992px) {
    position: relative;
    margin-top: unset;
    right: unset;
  }
`;

export const DiagonalBlueData = styled.div`
  background-color: var(--white);
  width: 100%;
  height: 100px;
  position: absolute;
  bottom: 0;
  z-index: 1;
  clip-path: polygon(300% 0%, 100% 0%, 100% 100%, 0% 100%);
  @media (min-width: 992px) {
    clip-path: polygon(100% 0%, 100% 0%, 100% 100%, 0% 100%);
  }
`;
